<div
  class="siteList__site"
  [class.siteList__siteName--disabled]="disabledReason"
  (click)="openSiteCallback(ppWorkspaceId)"
  >
  @if (
    disabledReason === 'noFields' || disabledReason === 'noTags' || disabledReason === 'noUsers'
    ) {
    <h6
      ppTooltip
      [ppTitle]="disabledTooltip"
      [ppOptions]="{ placement: 'right' }"
      class="siteList__siteName"
      >
      {{ ppWorkspace?.siteName }}
    </h6>
  }

  @if (disabledReason === 'active' || !disabledReason) {
    <h6
      ppTooltip
      [ppTitle]="ppWorkspaceId === ppActiveWorkspaceId ? ('site_currently_on' | ppTranslate) : ''"
      [ppOptions]="{ placement: 'right' }"
      class="siteList__siteName"
      >
      {{ ppWorkspace?.siteName }}
    </h6>
  }

  @if (ppFieldsPerWorkspace[ppWorkspaceId] > 1) {
    <p class="selectedCustomFieldsCounter copy">
      {{ ppFieldsPerWorkspace[ppWorkspaceId] }}
      {{ SiteListSelectTypesMultiple[ppType] | ppTranslate }}
    </p>
  }

  @if (ppFieldsPerWorkspace[ppWorkspaceId] === 1) {
    <p class="selectedCustomFieldsCounter copy">
      {{ ppFieldsPerWorkspace[ppWorkspaceId] }} {{ SiteListSelectTypesSingle[ppType] | ppTranslate }}
    </p>
  }
</div>
